import { action, observable } from 'mobx'
import Ds from './ds'

class Mailchimp {
  /**
   * Observables
   **/
  @observable ds = new Ds()

  @observable memberInfo = []
  @observable addMemberResults = []
  @observable removeMemberResults = []


  /**
   * Actions
   **/
  @action resetMemberInfo() {
    this.memberInfo = []
  }

  @action mailchimpGetSubInfo(email, callback) {
    const query = `mutation { mailchimpGetSubInfo( email: "${email}", hash: "${localStorage.getItem('userHash')}" ) { statusCode data } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.memberInfo = data.mailchimpGetSubInfo

      if (callback) {
        callback(this.memberInfo)
      }
    })
  }

  @action addMemberToList(listId, data, callback) {
    const query = `mutation { addMemberToList( listId: "${ listId }", email: "${ data.email }", firstName: "${ data.firstName }", lastName: "${ data.lastName }", hash: "${localStorage.getItem('userHash')}" ) { statusCode data } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.addMemberResults = data.addMemberToList

      if (callback) {
        callback(this.addMemberResults)
      }
    })
  }

  @action removeMemberFromList(data, callback) {
    const query = `mutation { removeMemberFromList( listId: "${ data.listId }", memberId: "${ data.memberId }", hash: "${localStorage.getItem('userHash')}" ) { statusCode data } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.removeMemberResults = data.removeMemberFromList

      if (callback) {
        callback(this.removeMemberResults)
      }
    })
  }
}

export default new Mailchimp()



// WEBPACK FOOTER //
// ./src/stores/mailchimp.js